import React, { useState, useRef, useEffect, useId } from 'react';
import CareerButton from './careerbutton';
import PopupHover from './PopupHover';


const CareerWheelItem = ({
  skill,
  angle,
  radius,
  isLeftSide,
  onCareerClick,
}) => {
  const buttonRef = useRef(null);
  const tooltipId = useId();
    const [isHovering, setIsHovering] = useState(false);
  const [canHover, setCanHover] = useState(false);

  useEffect(() => {
    const el = buttonRef.current;
    if (!el) return;

    const mediaQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
    const updateCanHover = () => setCanHover(mediaQuery.matches);
    updateCanHover();

    const show = () => setIsHovering(true);
    const hide = () => setIsHovering(false);

    if (mediaQuery.matches) {
      el.addEventListener("mouseenter", show);
      el.addEventListener("mouseleave", hide);
    }

    const handleChange = () => {
      updateCanHover();
      if (!mediaQuery.matches) {
        setIsHovering(false);
        el.removeEventListener("mouseenter", show);
        el.removeEventListener("mouseleave", hide);
      } else {
        el.addEventListener("mouseenter", show);
        el.addEventListener("mouseleave", hide);
      }
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      el.removeEventListener("mouseenter", show);
      el.removeEventListener("mouseleave", hide);
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  return (
    <div
      className="group absolute top-1/2 left-1/2 -translate-x-1/2"
      style={{
        transform: `rotate(${angle}deg) translate(${radius}px) rotate(-${angle}deg)`,
        width: "160px",
        marginLeft: isLeftSide ? "-120px" : "-40px",
        textAlign: "center",
      }}
    >
      <PopupHover career={skill} parentRef={buttonRef} active={canHover && isHovering} tooltipId={tooltipId} />

      <CareerButton
        ref={buttonRef}
        onClick={() => onCareerClick(skill)}
        aria-label={`Career option: ${skill.profession_name}`}
        aria-describedby={tooltipId}
      >
        {skill.profession_name}
      </CareerButton>
    </div>
  );
};

const CareerWheel = ({ label, data, onCareerClick }) => {
  const radius = 110;
  const containerSize = radius * 2 + 50;

  return (
    <div
      className="relative mx-auto w-full max-w-3xl text-center"
      role="region"
      aria-label={`Career wheel for ${label}`}
    >
      <div className="relative mx-auto" style={{ height: containerSize }}>
        <div
          className="relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-32 h-32 border-2 border-dashed border-border bg-white rounded-full text-center font-bold"
          role="status"
        >
          {label}
        </div>

        {data.map((skill, index) => {
          const angle = (index / data.length) * 360;
          const isLeftSide = angle > 90 && angle < 270;
          /*const isTopOrBottom =
    angle < 20 || angle > 340 || (angle > 160 && angle < 200);

  let marginLeft = '-40px';
  let textAlign = 'left';

  if (isLeftSide) {
    marginLeft = '-120px';
    textAlign = 'right';
  }

  if (isTopOrBottom) {
    marginLeft = '-60px';
    textAlign = 'center';
  }*/
          return (
            <CareerWheelItem
              key={skill.profession_name}
              skill={skill}
              angle={angle}
              radius={radius}
              isLeftSide={isLeftSide}
              onCareerClick={onCareerClick}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CareerWheel;
